import { Alert, AlertTitle, Box, Typography } from '@mui/material'
import { useHolisticPlanIssues } from '../../hooks/data/useHolisticPlanIssues'
import type { HolisticPlanIssue } from '../../types/apiModels'
import { PROGRAM_IDS } from '../../utils/constants'

type HolisticPlanIssuesWarningProps = {
  farm: { id: string; programId?: number }
  year: string
}

const IssueSection = ({ title, issues }: { title: string; issues: HolisticPlanIssue[] }) => {
  if (!issues.length) return null

  return (
    <Box sx={{ mt: 1 }}>
      <Typography sx={{ fontWeight: 'bold' }} variant="body2">
        {title}
      </Typography>
      {issues.map(issue => (
        <Typography key={`${issue.earlierPlan.id}-${issue.laterPlan.id}`} variant="body2">
          {issue.message}
        </Typography>
      ))}
    </Box>
  )
}

const HolisticPlanIssuesWarning = ({ farm, year }: HolisticPlanIssuesWarningProps) => {
  const enabled = farm.programId === PROGRAM_IDS.SARA && !!farm.id && !!year
  const { data, isError, isLoading } = useHolisticPlanIssues({
    farmId: farm.id,
    year,
    enabled,
  })

  if (!enabled || isLoading) return null

  if (isError) {
    return (
      <Alert severity="error" sx={{ mx: 2, my: 1 }}>
        No se pudieron verificar las fechas de los planes holísticos. Intente nuevamente más tarde.
      </Alert>
    )
  }

  if (!data || (!data.sameYear.length && !data.crossYear.length)) return null

  return (
    <Alert severity="warning" sx={{ mx: 2, my: 1 }}>
      <AlertTitle>Fechas de planes holísticos a corregir</AlertTitle>
      <Typography variant="body2">
        Los registros se pueden guardar, pero el Técnico de Campo no podrá enviar la declaración
        anual a revisión hasta corregir estas fechas. Un plan puede comenzar el mismo día en que
        termina el anterior o el día siguiente.
      </Typography>
      <IssueSection issues={data.sameYear} title={`En ${year}`} />
      <IssueSection issues={data.crossYear} title={`Entre ${Number(year) - 1} y ${year}`} />
    </Alert>
  )
}

export default HolisticPlanIssuesWarning
